// extracted by mini-css-extract-plugin
export var compactFilters = "_ci-4";
export var detailImage = "_ci-1";
export var dropdownContainer = "_ci-2";
export var imageContainer = "_ci-0";
export var selectedCard = "_ci-3";